module.exports = __webpack_public_path__ + "img/red-cross.530041e7.svg";